import { RenderIf } from "shared/components";
import { VIEW_MODES } from "shared/contexts/ViewMode";

import { BlockType } from "./BlockType";
import { ButtonAdd } from "./ButtonAdd";
import styles from "./Content064.module.scss";
import { WidgetProvider } from "./Content064.Provider";
import { ModalCoursesList } from "./ModalCoursesList";

export const Content064 = ({ payload }) => {
  return (
    <WidgetProvider payload={payload}>
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <RenderIf viewMode={VIEW_MODES.DESKTOP}>
            <ButtonAdd />
          </RenderIf>
          <BlockType />
        </div>
      </div>
      <ModalCoursesList />
    </WidgetProvider>
  );
};

export default Content064;
